import React from 'react';
import PropTypes from 'prop-types';
import VerticalLabelList from '../../../../label/VerticalLabelList';
import FieldSet from '../../../../fieldset/FieldSet';
import '../UtilityView.css';

class KsDmvDetailedRenewal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { license, } = this.props;
    const containsAddressChangeData = license.renewalRequest.addressData !== null && license.renewalRequest.addressData.NewAddress1 !== '';

    const licenseItems = VerticalLabelList.toList({
      'Drivers License Number': license.renewalRequest.driversLicenseNumber,
      'Organ Donor': license.renewalRequest.organDonor,
      'Email Opt In': license.renewalRequest.emailOptIn !== null ? license.renewalRequest.emailOptIn : '',
      'Optometrist Name': license.renewalRequest.optometristName,
      'Optometrist Email': license.renewalRequest.optometristEmail,
      'Corrective Lenses': license.renewalRequest.correctiveLenses,
      'License Fee': license.renewalRequest.licenseFee,
      'Late Fee': license.lateFee,
      'Photo Fee': license.photoFee,
      'Endorsement Fee': license.endorsementFee,
      'License Classes': license.licenseClasses,
      'CDL Endorsement': license.cdlEndorsement,
      'Medical Category': license.medicalCategory,
    });

    let residentialAddressItems;
    if (containsAddressChangeData) {
      residentialAddressItems = VerticalLabelList.toList({
        'Address Line 1': license.renewalRequest.addressData.NewAddress1,
        'Address Line 2': license.renewalRequest.addressData.NewAddress2,
        City: license.renewalRequest.addressData.NewCity,
        State: license.renewalRequest.addressData.NewState,
        ZIP: license.renewalRequest.addressData.NewZip,
        County: license.renewalRequest.addressData.NewCounty,
        'Is Mailing & Residential Address the Same': license.renewalRequest.addressData.IsMailResidentialSame,
      });
    }
    let mailingAddressItems;
    if (containsAddressChangeData) {
      mailingAddressItems = VerticalLabelList.toList({
        'Address Line 1': license.renewalRequest.addressData.MailAddress1,
        'Address Line 2': license.renewalRequest.addressData.MailAddress2,
        City: license.renewalRequest.addressData.MailCity,
        State: license.renewalRequest.addressData.MailState,
        ZIP: license.renewalRequest.addressData.MailZip,
        County: license.renewalRequest.addressData.MailCounty,
      });
    }

    const ownerItems = VerticalLabelList.toList({
      'First Name': license.firstName,
      'Middle Name': license.middleName,
      'Last Name': license.lastName,
      'Phone Number': license.renewalRequest.phone,
      'Email Address': license.renewalRequest.email,
    });

    const transactionItems = VerticalLabelList.toList({
      'Transaction Id': license.renewalRequest.transactionId,
    });

    if (containsAddressChangeData) {
      return (
        <div>
          <div className="column-2" style={{ marginTop: '50px', }}>
            <FieldSet title="License Information">
              <VerticalLabelList
                items={licenseItems}
              />
            </FieldSet>
          </div>

          <div className="column-2" style={{ marginTop: '50px', }}>
            <FieldSet title="Residential Address Information Information">
              <VerticalLabelList
                items={residentialAddressItems}
              />
            </FieldSet>
          </div>

          <div className="column-2" style={{ marginTop: '50px', }}>
            <FieldSet title="Mailing Address Information Information">
              <VerticalLabelList
                items={mailingAddressItems}
              />
            </FieldSet>
          </div>

          <div className="column-2" style={{ marginTop: '20px', }}>
            <FieldSet title="Owner Information">
              <VerticalLabelList
                items={ownerItems}
              />
            </FieldSet>
          </div>

          <div className="column-2" style={{ marginTop: '20px', }}>
            <FieldSet title="Transaction Information">
              <VerticalLabelList
                items={transactionItems}
              />
            </FieldSet>
          </div>
        </div>
      );
    }

    return (
      <div>
        <div className="column-2" style={{ marginTop: '50px', }}>
          <FieldSet title="License Information">
            <VerticalLabelList
              items={licenseItems}
            />
          </FieldSet>
        </div>

        <div className="column-2" style={{ marginTop: '20px', }}>
          <FieldSet title="Owner Information">
            <VerticalLabelList
              items={ownerItems}
            />
          </FieldSet>
        </div>

        <div className="column-2" style={{ marginTop: '20px', }}>
          <FieldSet title="Transaction Information">
            <VerticalLabelList
              items={transactionItems}
            />
          </FieldSet>
        </div>
      </div>
    );
  }
}

KsDmvDetailedRenewal.propTypes = {
  license: PropTypes.instanceOf(Object).isRequired,
};

export default KsDmvDetailedRenewal;
